import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const Footer = () => {
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for subscribing! (This is a demo)');
  };

  return (
    <footer className="bg-gradient-to-br from-blue-900 via-teal-800 to-green-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_dadtime-guides/artifacts/y6hj3s71_Dad%20connect%20logo.png" 
                alt="DadConnect" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-blue-100 text-sm">
              Building stronger connections between fathers and their children, one activity at a time.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/activities" className="text-blue-200 hover:text-teal-300 transition-colors text-sm">
                  Activities
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-blue-200 hover:text-teal-300 transition-colors text-sm">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/self-improvement" className="text-blue-200 hover:text-teal-300 transition-colors text-sm">
                  Self-Improvement
                </Link>
              </li>
              <li>
                <Link to="/mentorship" className="text-blue-200 hover:text-teal-300 transition-colors text-sm">
                  Mentorship Program
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-blue-200 text-sm">
                <Mail className="h-4 w-4" />
                <span>andrew@dadconnect.com</span>
              </li>
              <li className="flex items-center space-x-2 text-blue-200 text-sm">
                <MapPin className="h-4 w-4" />
                <span>Based in the USA</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Newsletter</h3>
            <p className="text-blue-200 text-sm mb-4">
              Get monthly tips and activity ideas delivered to your inbox.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="space-y-2">
              <Input
                type="email"
                placeholder="Your email"
                className="bg-teal-800 border-teal-600 text-white placeholder:text-teal-300"
                required
              />
              <Button 
                type="submit"
                className="w-full bg-gradient-to-r from-blue-500 to-teal-500 hover:from-blue-600 hover:to-teal-600 text-white"
              >
                Subscribe
              </Button>
            </form>
          </div>
        </div>

        <div className="border-t border-teal-600 mt-8 pt-8 text-center text-blue-200 text-sm">
          <p>&copy; {new Date().getFullYear()} DadConnect. All rights reserved.</p>
          <p className="mt-2">
            <Link to="/privacy" className="hover:text-teal-300 transition-colors">Privacy Policy</Link>
            {' • '}
            <Link to="/terms" className="hover:text-teal-300 transition-colors">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;